import {
  Popover as MaterialPopover,
  PopoverContent as MaterialPopoverContent,
  type PopoverContentProps as MaterialPopoverContentProps,
  PopoverHandler as MaterialPopoverHandler,
  type PopoverHandlerProps as MaterialPopoverHandlerProps,
  type PopoverProps as MaterialPopoverProps,
} from '@material-tailwind/react';
import { useCallback, useEffect, useState } from 'react';

export type PopoverProps = MaterialPopoverProps & { disabled?: boolean };

export const Popover = ({
  children,
  disabled,
  handler,
  open: openFromProps,
  ...rest
}: PopoverProps) => {
  const [open, setOpen] = useState(openFromProps);
  useEffect(() => setOpen(openFromProps), [openFromProps]);

  const popoverHandler = useCallback(
    (value: boolean) => {
      if (disabled) {
        return;
      }
      setOpen(value);
      handler?.(value);
    },
    [disabled, handler],
  );

  return (
    <MaterialPopover open={open} handler={popoverHandler} {...rest}>
      {children}
    </MaterialPopover>
  );
};

export type PopoverHandlerProps = MaterialPopoverHandlerProps;
export const PopoverHandler = ({ children, ...rest }: PopoverHandlerProps) => (
  <MaterialPopoverHandler {...rest}>
    <div>{children}</div>
  </MaterialPopoverHandler>
);

export type PopoverContentProps = MaterialPopoverContentProps;
export const PopoverContent = ({ children, ...rest }: PopoverContentProps) => (
  // @ts-expect-error The Material Types are wrong.
  <MaterialPopoverContent placeholder={undefined} {...rest}>
    {children}
  </MaterialPopoverContent>
);
